"use client";

import React from "react";
import { SVariantDto } from "@/__generated__/graphql";
import { SelectedAttributes, AttributeGroup } from "./ProductPageProvider";
import { PricingModeGuideRequest } from "../components/CartModeGuideDialog";

export type ProductPageVariantsMode = 'withAttrs' | 'withOutAttrs' | 'mixed'


type ProductPageContextType = {
  
  productId: string;

  mode: ProductPageVariantsMode,
  variants: SVariantDto[];

  selectedVariant?: SVariantDto;

  /** All in-stock variants matching selected attributes (multi-warehouse sellers). */
  matchingVariants: SVariantDto[];

  selectedAttrs: SelectedAttributes;

  selectAttribute: (name: string, value: string) => void;

  attributeGroups: AttributeGroup[];

  anyVariantAvailableToSell: boolean;

  variantToShow: SVariantDto | null;

  hasOffer: boolean;

  hasAnyOffer: boolean;
  onAddToCart:(callback: () => void) => string[] | null
  tempError?:string |null
  /** Attribute names the shopper still needs to pick before buying. */
  promptedAttrs: string[]
  promptForAttributes: () => void
  /** Opens the cash/credit mismatch guide instead of the blocking cart error. */
  openPricingModeGuide: (request: PricingModeGuideRequest) => void
};

export const ProductPageContext = React.createContext<ProductPageContextType | undefined>(undefined);
